import { render, staticRenderFns } from "./PremiumOccupationalConsultNotePrint.vue?vue&type=template&id=ecbe28c0&scoped=true&"
import script from "./PremiumOccupationalConsultNotePrint.vue?vue&type=script&lang=js&"
export * from "./PremiumOccupationalConsultNotePrint.vue?vue&type=script&lang=js&"
import style0 from "./PremiumOccupationalConsultNotePrint.vue?vue&type=style&index=0&id=ecbe28c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecbe28c0",
  null
  
)

export default component.exports